import React from 'react';
function MinimalLayout(props) {
  return <div>{props.children}</div>;
}

export default MinimalLayout;
